import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider />
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <HelmetProvider />
  </React.StrictMode>
);

// ✅ Remove preloader when window fully loads
window.addEventListener("load", () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.opacity = "0";
    preloader.style.transition = "opacity 0.4s ease";
    setTimeout(() => {
      preloader.remove();
    }, 400); // match the transition duration
  }
});
